import { useState, useEffect } from 'react'
import { useProgramStore } from '../../../../store/useProgramStore'
import ApiClient from '../../../api/client'

const apiClient = new ApiClient()

const UpdateProgramModal = () => {
  const { showUpdateModal, closeUpdateModal, programToUpdate, updateProgram } =
    useProgramStore()

  const [name, setName] = useState('')
  const [newCode, setNewCode] = useState('')
  const [programCode, setProgramCode] = useState('')
  // const [program, setProgram] = useState([])
  const [image, setImage] = useState(null)
  const [previewImage, setPreviewImage] = useState(null)

  useEffect(() => {
    if (programToUpdate) {
      setName(programToUpdate.name || '')
      setProgramCode(programToUpdate.program_code || '')
      setImage(null)
      setPreviewImage(programToUpdate.image || null)
    }
    const fetchProgram = async () => {
      await apiClient.fetchAllPrograms()
      // if (data) {
      //   // setProgram(data)
      // }
    }
    fetchProgram()
  }, [showUpdateModal])

  if (!showUpdateModal) return null

  const handleUpdate = async () => {
    await updateProgram(programToUpdate.id, name, newCode, image)
    // closeUpdateModal()
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-lg p-6 w-[80%] max-w-md shadow-xl">
        <div className="flex flex-col justify-center w-full">
          <h2 className="text-lg font-semibold mb-4">Update Program</h2>
          <div className="grid text-center justify-center rounded-full pointer p-2 w-full">
            <img
              className="rounded-full pointer w-20 h-20"
              src={previewImage}
              alt=""
            />
            <p>
              <span>{name}</span>({programCode})
            </p>
          </div>
        </div>
        <input
          className="w-full border mb-2 p-2 rounded"
          type="text"
          value={name}
          name="name"
          onChange={(e) => setName(e.target.value)}
          placeholder="Change Program Name"
        />
        <input
          className="w-full border mb-2 p-2 rounded"
          type="file"
          name="image"
          accept="image/*"
          onChange={(e) => setImage(e.target.files[0])}
          placeholder="Email"
        />
        <input
          className="w-full border mb-2 p-2 rounded"
          type="text"
          value={newCode}
          name="name"
          onChange={(e) => setNewCode(e.target.value)}
          placeholder="Change Program Code"
        />

        {/* <select
          name="program"
          id="program"
          value={programId}
          className="w-full border mb-4 p-2 rounded"
          onChange={(e) => setProgramId(parseInt(e.target.value))}
          placeholder="Program"
        >
          <option value="">Select Program</option>
          {program.map((prog) => (
            <option key={prog.id} value={prog.id}>
              {prog.name}
            </option>
          ))}
        </select> */}

        {/* <input
          className="w-full border mb-4 p-2 rounded"
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          placeholder="Status"
        /> */}

        <div className="flex justify-end space-x-3">
          <button
            onClick={closeUpdateModal}
            className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            onClick={handleUpdate}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  )
}

export default UpdateProgramModal
